export var version = '3.7.16';
//# sourceMappingURL=version.js.map